import { __extends } from "tslib";
import { EventBase } from '@awayjs/core';
var ContainerEvent = /** @class */ (function (_super) {
    __extends(ContainerEvent, _super);
    function ContainerEvent(type, entity, index) {
        if (entity === void 0) { entity = null; }
        if (index === void 0) { index = null; }
        var _this = _super.call(this, type) || this;
        _this.entity = entity;
        _this.index = index;
        return _this;
    }
    /**
     * Clones the event.
     * @return An exact duplicate of the current object.
     */
    ContainerEvent.prototype.clone = function () {
        return new ContainerEvent(this.type, this.entity, this.index);
    };
    /**
     *
     */
    ContainerEvent.ADD_CHILD_AT = 'addChildAt';
    /**
     *
     */
    ContainerEvent.REMOVE_CHILD_AT = 'removeChildAt';
    /**
     *
     */
    ContainerEvent.INVALIDATE_ENTITY = 'invalidateEntity';
    /**
     *
     */
    ContainerEvent.CLEAR_ENTITY = 'clearEntity';
    return ContainerEvent;
}(EventBase));
export { ContainerEvent };
